import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { SelfServeSignupPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/SelfServeSignupPageCompletedEventTracking';

export class OnboardingNamePageCompletedEventTracking extends SelfServeSignupPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_NAME_PAGE_COMPLETED;
  name?: string;

  constructor(eventProperties: Partial<OnboardingNamePageCompletedEventTracking> = {}) {
    super(eventProperties);
    this.name = eventProperties?.name;
  }
}
